import type { RoomResponse } from '../types/auth';

/**
 * CORE-1328 — кто автор сессии, а не кто ведёт её сейчас.
 *
 * После передачи управления `hostUserId`/`hostName` — это получатель, и всё,
 * что отвечает на вопрос «чей эфир» (строка «Автор», «от …», карточка мастера,
 * ссылка на профиль), читало его. QA 11.09 (комната 4173): Б завершил эфир, и
 * итоговый экран назвал автором Б, хотя сервер отдавал автора А.
 *
 * Правило:
 * - сессию не передавали (или стенд без CORE-1328 не шлёт `creator*`) — автор
 *   и ведущий один человек, берутся поля ведущего;
 * - передавали — только поля автора. Имя ведущего сюда не подставляется даже
 *   при пустом `creatorName`: подпись «Автор: Б» хуже, чем её отсутствие.
 */
export interface RoomAuthor {
  userId: string;
  name: string;
  avatarUrl: string | null;
}

type RoomIdentity = Pick<
  RoomResponse,
  'hostUserId' | 'hostName' | 'hostAvatarUrl' | 'creatorUserId' | 'creatorName' | 'creatorAvatarUrl'
>;

export function resolveRoomAuthor(room: RoomIdentity): RoomAuthor {
  const handedOver = !!room.creatorUserId && room.creatorUserId !== room.hostUserId;
  if (!handedOver) {
    return {
      userId: room.hostUserId,
      name: room.creatorName?.trim() || room.hostName,
      avatarUrl: room.creatorAvatarUrl ?? room.hostAvatarUrl ?? null,
    };
  }
  return {
    userId: room.creatorUserId!,
    name: room.creatorName?.trim() || '',
    avatarUrl: room.creatorAvatarUrl ?? null,
  };
}
